<div class="row p-t-20">
    <div class="col-md-6">
        <div class="form-group">
            <label class="control-label">Código 1</label>
            <select id="scaleSelector" [(ngModel)]="code1" class="form-control custom-select">
                <option *ngFor="let scale of scales | mfm" [value]="scale.scale">A-{{scale.scale}}</option>
                <option value="sinCodigo">Perfil sin código</option>
            </select>
        </div>
    </div>

    <div class="col-md-6">
        <div class="form-group">
            <label class="control-label">Código 2</label>
            <select id="scaleSelector" [(ngModel)]="code2" class="form-control custom-select">
                <option *ngFor="let scale of scales | mfm" [value]="scale.scale">A-{{scale.scale}}</option>
                <option value="Perfil sin código">Perfil sin código</option>
            </select>
        </div>
    </div>

</div>
<div class="col-md-12">
    <div class="row justify-content-center">
        <div class="NgxEditor__Wrapper p-20 m-b-40 col-12">
            <ngx-editor-menu *ngIf="editor" [editor]="editor"> </ngx-editor-menu>
            <ngx-editor
              [editor]="editor"
              [(ngModel)]="html"
              [placeholder]="'Escriba su texto...'"
              [ngModelOptions]="{standalone:true}"
            ></ngx-editor>
        </div>
    </div>
</div>

<button *ngIf="!isEditing" type="button" (click)="create()" class="btn btn-rounded waves-effect btn-success">Crear combinación</button>
<button *ngIf="isEditing" type="button" (click)="update()" class="btn btn-rounded waves-effect btn-success">Actualizar combinación</button>

<div class="table-responsive m-t-20">
    <h4 class="card-title">Combinaciones</h4>
    <div class="table-responsive">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>Código</th>
                    <th class="text-nowrap">Acción</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of codes; index as i">
                    <td *ngIf="row.code1!='Perfil sin código'&&row.code2!='Perfil sin código'">A-{{row.code1}}A-{{row.code2}}/A-{{row.code2}}A-{{row.code1}}</td>
                    <td *ngIf="row.code1=='Perfil sin código'||row.code2=='Perfil sin código'">Perfil sin código</td>
                    <td class="text-center">
                        <a href="javascript:void(0)" (click)="handleDelete(row, i)" data-toggle="tooltip" data-original-title="Borrar"> <i class="fa fa-close text-danger m-r-20"></i> </a>
                        <a href="javascript:void(0)" (click)="handleEdit(row)"> <i class="fa text-dark fa-pencil"></i> </a>
                    </td>
                </tr>
             </tbody>
        </table>
    </div>
</div>
